import { Component } from "react";

import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ListBanquesToPayement from "../../../models/ListBanquesToPayement";
import BCService from "../../../services/BC";
import SalesService from "../../../services/SellingService";
import getCurrentUserId from "../../../reduxSaga/sagas/requests/currentUserId";
class PayementAvanceBillEnLigne extends Component {
  state = {
    numeroCard: "",
    amount: 0,
    amountMax: "",
    selectedFile: null,
    urlFile: "",
  };

  constructor(props) {
    super(props);
    this.state = {
      numeroCard: "",
      amount: 0,
      amountMax: "",
      selectedFile: null,
      urlFile: "",
    };
    this.changeNumeroCarte = this.changeNumeroCarte.bind(this);
    this.changeAmount = this.changeAmount.bind(this);
  }

  changeNumeroCarte(event) {
    this.setState({ numeroCard: event.target.value });
  }

  onFileChangeHandler = (event) => {
    this.setState({
      selectedFile: event.target.files[0],
      loaded: 0,
    });
  };
  UploadFile = () => {
    const dataFile = new FormData();
    dataFile.append("file", this.state.selectedFile);

    // original UploadFileService.uploadFileBill(dataFile).then((res) => {
    //   console.log("name File image", res.data["Bill"]);
    //   this.setState({
    //     urlFile: res.data["Bill"],
    //   });

    //   console.log(res.statusText);
    // });
  };

  payerBill = (e) => {
    const url = window.location.pathname.split("/")[1];
    if (url === "payerBill") {
      if (this.state.amount === 0) {
        toast.error("Erreur : le champ montant  est vide");
      } else if (this.state.amount > this.props.restToPay) {
        toast.error("Erreur : montant est supérieur au Reste à payer");
      } else if (localStorage.getItem("banqueAccount") == null) {
        toast.error("Erreur : le champ compte bancaire est vide");
      } else {
        let payFactureOrAvance = {
          idUser: getCurrentUserId(),

          isFactureOrBDC: 1,
          idDocument: parseInt(localStorage.getItem("idBill")),

          isAvanceOrTotalPayement: 0,

          typePayement: 1,
          urlFile: "any",

          ammountPayed: this.state.amount.toString(),

          banqueAccountId: parseInt(localStorage.getItem("banqueAccount")),
        };

        BCService.payFactureOrBDC(payFactureOrAvance)
          .then((response) => {
            if (response.data["error"]) {
              toast.error("Error : il ya un probléme");
            } else {
              toast.success("ajouté avec succès");

              window.location.reload(false);
            }
          })
          .catch((error) => {
            toast.error("Error : il ya un probléme");

            window.location.reload(false);
          });
      }
    } else {
      if (this.state.amount === 0) {
        toast.error("Erreur : le champ montant  est vide");
      } else if (this.state.amount > this.props.restToPay) {
        toast.error("Erreur : montant est supérieur au Reste à payer");
      } else if (localStorage.getItem("banqueAccount") == null) {
        toast.error("Erreur : le champ compte bancaire est vide");
      } else {
        let payFactureOrAvance = {
          idUser: getCurrentUserId(),

          isFactureOrBDC: 1,

          idDocument: parseInt(localStorage.getItem("idBill")),

          isAvanceOrTotalPayement: 0,

          typePayement: 1,
          urlFile: "any",

          ammountPayed: this.state.amount.toString(),

          banqueAccountId: parseInt(localStorage.getItem("banqueAccount")),
        };

        SalesService.payFactureOrBDC(payFactureOrAvance)
          .then((response) => {
            if (response.data["error"]) {
              toast.error("Error : il ya un probléme");
            } else {
              toast.success("ajouté avec succès");

              window.location.reload(false);
            }
          })
          .catch((error) => {
            toast.error("Error : il ya un probléme");

            window.location.reload(false);
          });
      }
    }
  };

  changeAmount(event) {
    var amount = event.target.value;
    if (amount > this.props.restToPay) {
      this.setState({ alert_message: "error" });
    } else {
      this.setState({ amount: event.target.value });
    }

    // console.log("amount", this.state.amount);
  }

  render() {
    return (
      <div className="box-body">
        <br />
        <br />
        <label>Payement En ligne </label>
        <br />
        <ToastContainer />
        <div class="row">
          <div class="col-md-4">
            <label>Montant (ne pas dépasser {this.props.restToPay}): </label>
            <input
              type="number"
              min="0"
              step="0.1"
              max={this.props.restToPay.toString()}
              class="form-control"
              placeholder="Montant "
              name="amount"
              value={this.state.amount}
              onChange={this.changeAmount}
            />
          </div>
          <div class="col-md-8">
            <label>Compte bancaire</label>
            <ListBanquesToPayement type={1} />
          </div>
        </div>
        <div class="box-footer">
          <button
            style={{ marginTop: 20 }}
            type="submit"
            onClick={this.payerBill}
            className="btn btn-dark float-right"
          >
            Payer
          </button>
        </div>
      </div>
    );
  }
}
export default PayementAvanceBillEnLigne;
